<template>
  <div class="accumulator-selector__container">
    <div class="accumulator-selector__container__quick-search">
      <div class="accumulator-selector__container__quick-search__container">
        <h5>{{ $tv("quickSearch", "accumulatorSelector") }}</h5>
        <div class="accumulator-selector__container__quick-search__container__description">
          {{ $tv("quickSearchDescription", "accumulatorSelector") }}
        </div>
      </div>
      <div class="accumulator-selector__container__quick-search__button">
        <NuxtLink
          :to="getDetailLinkUrl()"
          target="_blank"
          class="k-button k-button-md k-button-solid k-button-solid-base"
        >
          <NavigationMenu class="button__icon tab" />
          {{ $tv('openAccumulatorPage', 'accumulatorSelector') }}
        </NuxtLink>
      </div>
    </div>

    <div class="accumulator-selector__container__cards">
      <div
        class="card"
      >
        <div class="card-content">
          <h5>{{ $tv("guidedFinderTitle", "accumulatorSelector") }}</h5>
          <div class="card-content__container">
            <div class="card-content__description">
              {{ $tv("guidedFinderDescription", "accumulatorSelector") }}
            </div>
            <div class="guided-finder-image">
              <img loading="lazy"
                src="~/assets/images/accumulator_guided_finder.png"
                alt="Accumulator Guided Finder"
              >
            </div>
          </div>
          <div class="card-content__button">
            <Button
              :theme-color="'base'"
              @click="goToGuidedFinder"
            >
              <span> {{ $tv('openGuidedFinder', 'accumulatorSelector') }}</span>
            </Button>
          </div>
        </div>
      </div>
      <div
        class="card"
      >
        <div class="card-content">
          <h5>{{ $tv("calculatorTitle", "accumulatorSelector") }}</h5>
          <div class="card-content__container">
            <div class="card-content__description">
              {{ $tv("calculatorDescription", "accumulatorSelector") }}
            </div>
            <div class="calculator-image">
              <AccumulatorCalculator />
            </div>
          </div>
          <div class="card-content__button">
            <Button
              :theme-color="'base'"
              @click="navigateTo(localePath('/accumulator-selector/calculator'))"
            >
              <span>{{ $tv('openCalculatorPage', 'accumulatorSelector') }}</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import NavigationMenu from '~/assets/icons/open_in_new.svg?component'
import AccumulatorCalculator from '~/assets/images/Accumulator_Calculator_v3.svg?component'
import useI18nExtended from '~/composables/usei18nExtended'
import {getUrlFromTechnicalName} from '~/mixins/category_urls'
import {Button} from '@progress/kendo-vue-buttons'
import {useAccumulatorSelectorStore} from '@/store/accumulator-selector'

const accumulatorSelectorStore = useAccumulatorSelectorStore()

const app = useNuxtApp()
const i18n = useI18nExtended()

const  getCategoryUrlFromTechnicalName = (t) => {
  return getUrlFromTechnicalName(t,  i18n.locale.value)
}

const getDetailLinkUrl = () => {
  return app.$globalization.localePath('/categories/' + getCategoryUrlFromTechnicalName('accumulator'.toLowerCase()))
}

const goToGuidedFinder = () => {
  accumulatorSelectorStore.resetState()
  navigateTo(app.$globalization.localePath('/accumulator-selector/guided-finder'))
}

</script>
<style lang="scss">
.accumulator-selector__container {
  width: 100%;
  margin-bottom: 2rem;

  &__quick-search {
    background-color: $color__fst__blue__010;
    padding: 1.5rem 1rem;
    display: flex;
    justify-content: space-between;

    &__container {
      &__description {
        padding-top: .75rem;
      }
    }

    h5 {
      margin: 0;
    }

    &__button {
      align-content: end;
      padding-top: .9375rem ;

      a {
        svg path[fill="#004388"] {
          fill:  $color__fst__white;
        }
      }
    }
  }

  &__cards {
    display: flex;
    width: 100%;

    .card {
      width: 50%;
      padding: 1rem;
      margin: 1.25rem .625rem 0;

      h5 {
        margin-top: 0;
        margin-bottom: 0;
        font-weight: $base-text-font-weight-semi-bold;
        line-height: 1.5rem;
      }

      .card-content__container {
        display: flex;
        justify-content: space-between;

        img {
          width:11.5625rem;
          height: 11.5625rem;
        }

        .calculator-image {
          .icon--svg {
            height: auto;
            width: auto;
            fill:$color__fst__primary ;
          }
        }
      }

      .card-content__button {
        display: flex;
        justify-content: flex-end;
        padding-top: 1rem;

        .guided-finder-image {
          img {
            width:11.5625rem;
            height: 11.5625rem;
          }
        }
      }

      .card-content__description {
        padding-top: 1rem;
        line-height: 1.125rem;
      }
    }

    .card:first-child {
      margin-left: 0;
    }

    .card:last-child {
      margin-right: 0;
    }
  }
}
</style>
